export var ActiveServicesReportEntryApiOccurrence = /*#__PURE__*/ function(ActiveServicesReportEntryApiOccurrence) {
    ActiveServicesReportEntryApiOccurrence["OneTime"] = "One-time";
    ActiveServicesReportEntryApiOccurrence["OnDemand"] = "On-demand";
    ActiveServicesReportEntryApiOccurrence["Daily"] = "Daily";
    ActiveServicesReportEntryApiOccurrence["Weekly"] = "Weekly";
    ActiveServicesReportEntryApiOccurrence["BiWeekly"] = "Bi-weekly";
    ActiveServicesReportEntryApiOccurrence["FirstAndFifteenth"] = "1st & 15th";
    ActiveServicesReportEntryApiOccurrence["FifteenthAndLast"] = "15th & Last";
    ActiveServicesReportEntryApiOccurrence["Monthly"] = "Monthly";
    ActiveServicesReportEntryApiOccurrence["Quarterly"] = "Quarterly";
    ActiveServicesReportEntryApiOccurrence["Yearly"] = "Yearly";
    ActiveServicesReportEntryApiOccurrence["InStages"] = "In-stages";
    return ActiveServicesReportEntryApiOccurrence;
}({});
export var ActiveServicesReportEntryApiTrigger = /*#__PURE__*/ function(ActiveServicesReportEntryApiTrigger) {
    ActiveServicesReportEntryApiTrigger["Manual"] = "Manual";
    ActiveServicesReportEntryApiTrigger["Automatic"] = "Automatic";
    return ActiveServicesReportEntryApiTrigger;
}({});
export var ActiveServicesReportEntryApiPricing = /*#__PURE__*/ function(ActiveServicesReportEntryApiPricing) {
    ActiveServicesReportEntryApiPricing["Fixed"] = "Fixed";
    ActiveServicesReportEntryApiPricing["Range"] = "Range";
    ActiveServicesReportEntryApiPricing["PerHour"] = "Per hour";
    ActiveServicesReportEntryApiPricing["PerUnit"] = "Per unit";
    return ActiveServicesReportEntryApiPricing;
}({});
export var ActiveServicesReportEntryApiAutomaticServiceState = /*#__PURE__*/ function(ActiveServicesReportEntryApiAutomaticServiceState) {
    ActiveServicesReportEntryApiAutomaticServiceState["Active"] = "Active";
    ActiveServicesReportEntryApiAutomaticServiceState["Paused"] = "Paused";
    return ActiveServicesReportEntryApiAutomaticServiceState;
}({});
export var ActiveServicesReportEntryApiStatus = /*#__PURE__*/ function(ActiveServicesReportEntryApiStatus) {
    ActiveServicesReportEntryApiStatus["Approved"] = "Approved";
    ActiveServicesReportEntryApiStatus["Amended"] = "Amended";
    ActiveServicesReportEntryApiStatus["Inactive"] = "Inactive";
    return ActiveServicesReportEntryApiStatus;
}({});
export var ActiveServicesReportSortColumnId = /*#__PURE__*/ function(ActiveServicesReportSortColumnId) {
    ActiveServicesReportSortColumnId["CompanyName"] = "companyName";
    ActiveServicesReportSortColumnId["ServiceName"] = "serviceName";
    ActiveServicesReportSortColumnId["Trigger"] = "trigger";
    ActiveServicesReportSortColumnId["Pricing"] = "pricing";
    ActiveServicesReportSortColumnId["Occurrence"] = "occurrence";
    ActiveServicesReportSortColumnId["Rate"] = "rate";
    ActiveServicesReportSortColumnId["LastBilled"] = "lastBilled";
    ActiveServicesReportSortColumnId["Assignee"] = "assignee";
    ActiveServicesReportSortColumnId["AutomaticServiceState"] = "automaticServiceState";
    ActiveServicesReportSortColumnId["Status"] = "status";
    return ActiveServicesReportSortColumnId;
}({});
